import type React from "react";
import type { ReactElement } from "react";

interface IAbsoluteContainerProps {
  children: ReactElement;
}

const AbsoluteContainer: React.FC<IAbsoluteContainerProps> = ({ children }) => {
  return <div className={"absolute top-0 left-0 w-svw"}>{children}</div>;
};

export default AbsoluteContainer;
